import { Button, colors, TableRow } from '@insurancemenu/imenu-components-lib';
import React from 'react';
import { DDARCustomUser } from 'types/formService';
import UsersTableCell from '../UsersTableCell';
import { createStyles } from './styles';

interface Props {
  user: DDARCustomUser;
  onEdit: (user: DDARCustomUser) => void;
  onDelete: (idToDelete: number) => void;
}

const UsersTableRow: React.FC<Props> = ({ user, onEdit, onDelete }) => {
  const classes = createStyles();
  return (
    <TableRow className={classes.user}>
      <UsersTableCell title="Full Name" data={user.fullName} width="12rem" />
      <UsersTableCell title="Email" data={user.email} width="13rem" />
      <UsersTableCell title="Eligibility Maintenance" data={user.eligibility} width="13rem" />
      <UsersTableCell title="Online Billing" data={user.billing} width="13rem" />
      <UsersTableCell
        width="2rem"
        customLayout={
          <>
            <Button type="text" color="primary" onClick={(): void => onEdit(user)}>
              Edit
            </Button>
            <Button type="text" color="custom" customColor={colors.red[500]} onClick={(): void => onDelete(user.id)}>
              Delete
            </Button>
          </>
        }
      />
    </TableRow>
  );
};

export default UsersTableRow;
